// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2oZQ6","col":"styles_col__dcM7g"};